import React, { useEffect, useRef, useState } from 'react'
import RoleInformation from './RoleInformation';
import PersonalInformation from './PersonalInformation';
import AddressInformation from './AddressInformation';
import FinancialInformation from './FinancialInformation';
import RegulatoryInformation from './RegulatoryInformation';
// import HouseholdReview from './HouseholdReview';
import { Grid, Step, StepLabel, Stepper, Typography } from '@mui/material';
import { useParams } from 'react-router';
import axiosInstance from 'custom-axios';
import { toast } from 'react-toastify';
import { useFormContext } from 'react-hook-form';

const HouseHoldStepper = ({ setParentErrorStepIndex, parentErrorStepIndex, setActiveChildStep, activeChildStep, formData, setFormData, setHouseHoldHomeComponent, activeParentStep, setActiveParentStep }) => {
    const { id } = useParams();
    const loginType = localStorage.getItem('login_type');
    // let childSteps = ['Role', 'Personal Information', 'Address', 'Financial', 'Regulatory', 'Review']
    const [childSteps, steChildSteps] = useState(['Role', 'Personal Information', 'Address', 'Financial', 'Regulatory'])
    const [houseHoldStepError, setHouseHoldStepError] = React.useState([false, false, false, false, false, false]); // Track errors for each step

    // const { getValues, setValue, trigger } = useFormContext();

    // console.log(getValues())
    const step0Ref = useRef();
    const step1Ref = useRef();
    const step2Ref = useRef();

    let stepRefs = [step0Ref, step1Ref, step2Ref, undefined, undefined, undefined]; // Only steps with validation and undefined that no validation required.

    const clickOnHouseHoldChildStep = async (index) => {

        const stepEndpoints = [
            'api/save-user-role-info',
            'api/save-user-personal-info',
            'api/save-user-address-info',
            'api/save-user-financial-info',
            'api/save-user-regulatory-info',
            'api/change-form-step'
        ];

        let isValid = true;
        let submitData;
        const endPoint = stepEndpoints[activeChildStep];

        // Perform validation for steps with refs
        if (stepRefs[activeChildStep]) {
            isValid = await stepRefs[activeChildStep].current.triggerValidation();
        }

        let updatedErrors = [...houseHoldStepError];
        updatedErrors[activeChildStep] = !isValid;
        setHouseHoldStepError(updatedErrors)

        const hasTrueValue1 = updatedErrors.some(value => value === true);

        const updatedErrorParentState = [...parentErrorStepIndex];

        if (hasTrueValue1) {
            updatedErrorParentState[0] = true; // Update index 1
        } else {
            updatedErrorParentState[0] = false; // Reset index 1
        }

        // console.log(updatedErrorParentState)

        if (endPoint === 'api/change-form-step') {
            // Submit without formData for the 'change-form-step' endpoint
            submitData = {
                child_household_error_step: updatedErrors,
                parent_error_step: updatedErrorParentState,
                user_id: id || 0,
                parent_step: 0,
                child_step: index
            };
        } else {
            // Default submit data including formData
            submitData = {
                // ...formData,
                child_household_error_step: updatedErrors,
                parent_error_step: updatedErrorParentState,
                user_id: id || 0,
                parent_step: 0,
                child_step: index
            };
        }


        try {

            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status == 500) {
                toast.error(response.message)
            }

        } catch (error) {
            console.error(error)
        }



        setActiveChildStep(index)

    }
    // console.log()
    const getHouseholdSteps = (progress) => {

        switch (progress) {
            case 0:
                return <RoleInformation roleRef={step0Ref} activeStep={activeChildStep} setActiveStep={setActiveChildStep} setHouseHoldHomeComponent={setHouseHoldHomeComponent} />;
            case 1:
                return <PersonalInformation personRef={step1Ref} activeStep={activeChildStep} setActiveStep={setActiveChildStep} />;
            case 2:
                return <AddressInformation addressRef={step2Ref} activeStep={activeChildStep} setActiveStep={setActiveChildStep} />;
            case 3:
                return <FinancialInformation /* financialRef={step3Ref} */ activeStep={activeChildStep} setActiveStep={setActiveChildStep} />;
            case 4:
                return <RegulatoryInformation /* regulatoryRef={step4Ref} */ activeStep={activeChildStep} setActiveStep={setActiveChildStep} setActiveParentStep={setActiveParentStep} />;
            // case 5:
            //     return <HouseholdReview /* householdReviewRef={step5Ref} */ formData={formData} setFormData={setFormData} activeStep={activeChildStep} setActiveStep={setActiveChildStep} activeParentStep={activeParentStep} setActiveParentStep={setActiveParentStep} />;
            default:
                break;
        }
    };

    const fetchAccountFormStep = async () => {

        try {

            const response = await axiosInstance.get(`api/fetch-form-step/${id}`);

            if (response.data) {

                const ChildErrorStepArray = response.data?.child_household_error_step
                    ? response.data.child_household_error_step
                        .split(",") // Split the string into an array
                        .map((value) => value === "1") // Convert "1" to true and "0" to false
                    : []; // Default to an empty array if null or undefined

                if (ChildErrorStepArray.length > 0) {
                    setHouseHoldStepError(ChildErrorStepArray);
                }

            }

        } catch (error) {
            console.error(error.message);
        }
    };

    useEffect(() => {

        // Check if there are any true values in houseHoldStepError after it updates
        const hasTrueValue = houseHoldStepError.some(value => value === true);
        // console.log('in');
        setParentErrorStepIndex((prevState) => {
            const updatedState = [...prevState];

            if (hasTrueValue) {
                updatedState[0] = true; // Update index 0
            } else {
                updatedState[0] = false; // Reset index 0
            }

            return updatedState;
        });

    }, [houseHoldStepError]); // Run this effect whenever houseHoldStepError changes


    useEffect(() => {

        let steps = [, 'Personal Information', 'Address', 'Financial', 'Regulatory', ,];
        // 'Role', 'Personal Information', 'Address', 'Financial', 'Regulatory', 'Review'
        if (loginType == 'client') {
            steChildSteps(steps)
        }
    }, [loginType]) // run this only childSteps change

    useEffect(() => {
        fetchAccountFormStep()
    }, [])
    return (
        <>
            {activeChildStep !== childSteps.length ? (
                <>
                    <div className='client-form-box'>
                        <div style={{ border: '1px solid #ced4da' }}>
                            <Grid item xs={12} sm={6} sx={{ paddingTop: '2.5rem' }}>
                                <Stepper activeStep={activeChildStep} alternativeLabel>

                                    {childSteps.map((label, index) => {

                                        const labelProps1 = {};

                                        if (houseHoldStepError[index]) {
                                            labelProps1.optional = (
                                                <Typography variant="caption" color="error">Error</Typography>
                                            );

                                            labelProps1.error = true;
                                        }

                                        return (
                                            <Step key={label}>
                                                <StepLabel
                                                    {...labelProps1}
                                                    onClick={() => clickOnHouseHoldChildStep(index)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {label}
                                                </StepLabel>
                                            </Step>
                                        )
                                    })}
                                </Stepper>
                            </Grid>
                            {getHouseholdSteps(activeChildStep)}
                        </div>
                    </div>
                </>
            ) : (
                null
            )
            }
        </>
    )
}

export default HouseHoldStepper